import React from "react";

const HealthStatus = () => (
  <div>
    <h2>Status: OK</h2>
  </div>
);

export default HealthStatus;
